export default {"src":"/_next/static/media/9.37bdb5e7.svg","height":140,"width":120,"blurWidth":0,"blurHeight":0};